import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import {TranslateModule} from '@ngx-translate/core';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {AuthComponent} from './auth.component';
import {LoginComponent} from './login/login.component';
import {AuthEffects, authReducer} from '../../../core/auth';
import {AuthService, PushNotificationService} from '../../../core/services';
import {SuumoLoginComponent} from './suumo-login/suumo-login.component';
import { isReadReducer } from '../../../core/reducers/is_read.reducers';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        RouterModule.forChild([
            {
                path: '',
                component: AuthComponent,
                children: [
                    {
                        path: '',
                        redirectTo: 'login',
                        pathMatch: 'full'
                    },
                    {
                        path: 'login',
                        component: LoginComponent,
                        data: {returnUrl: window.location.pathname}
                    },
                    {
                        path: 'suumo-login',
                        component: SuumoLoginComponent,
                        data: {returnUrl: window.location.pathname}
                    },
                    {
                        path: 'change-password',
                        component: ChangePasswordComponent,
                    },
                    {
                        path: 'change-password/:token',
                        component: ChangePasswordComponent,
                    },
                    {
                        path: 'forgot-password',
                        component: ForgotPasswordComponent,
                    }
                ]
            }
        ]),
        MatInputModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatTabsModule,
        TranslateModule.forChild(),
        StoreModule.forFeature('auth', authReducer),
        StoreModule.forFeature('isRead', isReadReducer),
        EffectsModule.forFeature([AuthEffects])
    ],
    exports: [AuthComponent],
    declarations: [
        AuthComponent,
        LoginComponent,
        SuumoLoginComponent,
        ChangePasswordComponent,
        ForgotPasswordComponent,
    ]
})
export class AuthModule {
    static forRoot(): ModuleWithProviders<AuthModule> {
        return {
            ngModule: AuthModule,
            providers: [
                AuthService,
                PushNotificationService
            ]
        };
    }
}
